import { UserApi } from '@/api/user'

const state = () => ({
	admins: [],
	adminPagination: {},
	admin: null,
	loadingAdmin: false,
	successAdmin: true,
	messageAdmin: '',
})

const getters = {
	admins: state => state.admins,
	adminPagination: state => state.adminPagination,
	admin: state => state.admin,
	loadingAdmin: state => state.loadingAdmin,
	successAdmin: state => state.successAdmin,
	messageAdmin: state => state.messageAdmin,
}

const actions = {
	async fetchListAdmins({commit}, query) {
		commit('setLoadingAdmin', true)
		await UserApi.listAdmin(query.perPage, query.page)
			.then(res => {
				commit('setAdmins', res.data.data)
				const pagination = {
					page: res.data.pages.current_page,
					perPage: res.data.pages.per_page,
					from: res.data.pages.from,
					total: res.data.pages.total
				}
				commit('setAdminPagination', pagination)
				commit('setLoadingAdmin', false)
			})
			.catch(err => {
				console.log(err)
				commit('setLoadingAdmin', false)
			})
	},
	async fetchDetailAdmin({commit}, id) {
		commit('setLoadingAdmin', true)
		await UserApi.detailAdmin(id)
			.then(res => {
				commit('setAdminDetail', res.data.data)
				commit('setLoadingAdmin', false)
			})
			.catch(err => {
				console.log(err)
				commit('setLoadingAdmin', false)
			})

	},
	async addAdmin({commit}, payload) {
		commit('setLoadingAdmin', true)
		await UserApi.addAdmin(payload)
			.then(res => {
				if(res.data.success) {
					commit('setLoadingAdmin', false)
					commit('setMessageAdmin', 'Berhasil Menambahkan Admin')
					commit('setSuccessAdmin', true)
				} else {
					commit('setLoadingAdmin', false)
					commit('setMessageAdmin', 'Terjadi Kesalahan')
					commit('setSuccessAdmin', false)
				}
			})
			.catch(err => {
				commit('setLoadingAdmin', false)
				commit('setMessageAdmin', err)
				commit('setSuccessAdmin', false)
			})
	},
	async updateAdmin({commit}, payload) {
		commit('setLoadingAdmin', true)
		await UserApi.editAdmin(payload)
			.then(res => {
				if(res.data.success) {
					commit('setLoadingAdmin', false)
					commit('setMessageAdmn', 'Berhasil Mengupdate Admin')
					commit('setSuccessAdmin', true)
				} else {
					commit('setLoadingAdmin', false)
					commit('setMessageAdmn', 'Terjadi Kesalahan')
					commit('setSuccessAdmin', false)
				}
			})
			.catch(err => {
				commit('setLoadingAdmin', false)
				commit('setMessagAdmin', err)
				commit('setSuccessAdmin', false)
			})
	},
	async deleteAdmin({commit}, id) {
		await UserApi.removeAdmin(id)
			.then(res => {
				if(res.data.success) {
					commit('setSuccessAdmin', true)
					commit('setMessageAdmin', 'Berhasil Menghapus Admin')
				} else {
					commit('setSuccessAdmin', false)
					commit('setMessagAdmin', 'Terjadi Kesalahan')
				}
			})
			.catch(err => {
				commit('setSuccessAdmin', false)
				commit('setMessagAdmin', err)	
			})
	},
}

const mutations = {
	setAdmins: (state, admins) => {
		state.admins = admins
	},
	setAdminPagination: (state, pagination) => {
		state.adminPagination = pagination
	},
	setAdminDetail: (state, detail) => {
		state.admin = detail
	},
	setLoadingAdmin: (state, loading) => {
		state.loadingAdmin = loading
	},
	setSuccessAdmin: (state, success) => {
		state.successAdmin = success
	},
	setMessageAdmin: (state, message) => {
		state.messageAdmin = message
	},
}

export default {
  state,
  getters,
  actions,
  mutations
}